var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1601 13.9282L15.3071 17.6469C15.7213 18.3643 15.4755 19.2817 14.758 19.6959C14.0406 20.1101 13.1232 19.8643 12.709 19.1469L10.0555 14.5508M18.4543 2.83011L18.8203 1.46408M20.4543 6.29422L21.8203 6.66025M7.09809 15.1603L17.7168 12.7288C19.0285 12.4284 19.6753 10.9446 19.0025 9.77923L14.7104 2.34513C14.0376 1.1798 12.4291 0.997997 11.5132 1.98376L4.09809 9.9641L7.09809 15.1603ZM4.34812 10.3971L6.84812 14.7272C7.26233 15.4447 7.01652 16.362 6.29908 16.7763C5.58164 17.1905 4.66425 16.9447 4.25004 16.2272L1.75004 11.8971C1.33583 11.1797 1.58164 10.2623 2.29908 9.84805C3.01652 9.43384 3.9339 9.67965 4.34812 10.3971Z",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.c4e18fe037ee9bc2d61fa57c1d3e2615.svg";
export { ForwardRef as ReactComponent };